/**
 * RichEditor 预设：simple / standard / full 三档工具栏。
 */

const FULL_PLUGINS = 'importcss autolink save code fullscreen image link codesample table charmap advlist lists';

/** simple：文字颜色、加粗、斜体、下划线、对齐、有序/无序列表、清除样式、源代码、全屏 */
const SIMPLE_PLUGINS = 'autolink advlist lists code fullscreen';
const SIMPLE_TOOLBAR = 'forecolor | bold italic underline | alignleft aligncenter alignright alignjustify | numlist bullist | removeformat | code fullscreen';

/** standard：simple 能力 + 背景色、链接、图片 */
const STANDARD_PLUGINS = 'autolink link image advlist lists code fullscreen';
const STANDARD_TOOLBAR = 'forecolor backcolor | bold italic underline | alignleft aligncenter alignright alignjustify | numlist bullist | link image | removeformat | code fullscreen';

/**
 * full：standard 能力 + 表格、特殊字符、撤销/重做、清除样式、源代码、全屏
 * 源代码与全屏固定置于工具栏末尾。
 */
const FULL_TOOLBAR_WITH_IMAGE = 'forecolor backcolor | bold italic underline | alignleft aligncenter alignright alignjustify | numlist bullist | link image table charmap | undo redo removeformat | code fullscreen';

function stripImageFromPlugins(plugins) {
    return plugins
        .replace(/\s*image\s*/, ' ')
        .replace(/\s+/g, ' ')
        .trim();
}

function stripImageFromToolbar(toolbar) {
    return toolbar
        .replace(/\s+image\b/g, '')
        .replace(/\|\s*\|/g, '|')
        .replace(/\s+/g, ' ')
        .trim();
}

/**
 * @param {'full'|'standard'|'simple'} mode
 * @param {{ includeImage?: boolean, medProjectStyle?: boolean }} options
 */
export function getPresetPlugins(mode, options = {}) {
    const { includeImage = true } = options;
    if (mode === 'simple') {
        return SIMPLE_PLUGINS;
    }
    if (mode === 'standard') {
        return includeImage ? STANDARD_PLUGINS : stripImageFromPlugins(STANDARD_PLUGINS);
    }
    return includeImage ? FULL_PLUGINS : stripImageFromPlugins(FULL_PLUGINS);
}

/**
 * @param {'full'|'standard'|'simple'} mode
 * @param {{ includeImage?: boolean, medProjectStyle?: boolean }} options
 */
export function getPresetToolbar(mode, options = {}) {
    const { includeImage = true } = options;
    if (mode === 'simple') {
        return SIMPLE_TOOLBAR;
    }
    if (mode === 'standard') {
        return includeImage ? STANDARD_TOOLBAR : stripImageFromToolbar(STANDARD_TOOLBAR);
    }
    let bar = FULL_TOOLBAR_WITH_IMAGE;
    if (!includeImage) {
        bar = stripImageFromToolbar(bar);
    }
    return bar;
}
